import { render, staticRenderFns } from "./MasterFabric.vue?vue&type=template&id=2fc547f0&"
import script from "./MasterFabric.vue?vue&type=script&lang=js&"
export * from "./MasterFabric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports